module.exports = __webpack_public_path__ + "static/img/11.717b10f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/11.png
// module id = NZbU
// module chunks = 0